import React from "react";

import "./PropertyComponent.css";
import { InsertPhoto, Map, Verified } from "@mui/icons-material";
import pascalprofil from "../img/pascalprofil.png";
import { useParams } from "react-router-dom";
import pascalphoto from "../img/pascalphoto.png";
import FeaturedProperties from "../components/FeaturedProperties";
import Gallery from "../components/Gallery";

import propertiesData from "../pages/Properties.json";
import Badge from "../components/Badge";


function PropertySample() {
  
  const { slug } = useParams();
  const property = propertiesData.find((p) => p.slug === slug)

  return (
    <div className="PropertySample">

      <div className="PropertySample__gallery">
        <Gallery property={property} />
      </div>
      <div className="PropertySample__icons">
        <div className="PropertySample__icons__txticon">
          <div className="PropertySample__icons__txticon__txt">
            <InsertPhoto />
          </div>
          <div className="PropertySample__icons__txticon__icon">
            <p>PHOTOS ({property.gallery.length})</p>
          </div>
        </div>
        <a href="https://maps.app.goo.gl/YuGNfJe9PrtLTopj8" style={{ color: "black", textDecoration:"none" }}>
          <div className="PropertySample__icons__txticon">
            <div className="PropertySample__icons__txticon__txt">
              <Map/>
            </div>
            <div className="PropertySample__icons__txticon__icon">
              <p>MAP</p>
            </div>
          </div>
        </a>
      </div>
      <div className="PropertySample__greyline"></div>
      <div className="PropertySample__main__infos">
        <div className="PropertySample__main__infos__left">
          <div className="PropertySample__main__infos__left__TITLE">
            <p>{property.name}</p>
          </div>
          <div className="PropertySample__main__infos__left__LOCATION">
            <p>{property.location}</p>
          </div>
          <div className="PropertySample__main__infos__left__PRICE">
            <p>{property.price}</p>
          </div>
          <div className="PropertySample__main__infos__left__CONTENT">
            <p>{property.bedrooms} Bedrooms • {property.bathrooms} Bathrooms • {property.housesize}</p>
          </div>
          <div className="PropertySample__main__infos__left__CONTENT">
            <br />
            <p>Ref: {property.ref}</p>
            <br />
          </div>
          <div className="PropertySample__main__infos__left__BADGE">
            <Badge label={property.status} badgecolor={property.badgecolor} />
          </div>
        </div>
        <div className="PropertySample__main__infos__right">
          <div className="PropertySample__main__infos__right__US">
            <p>US Exclusivity for Cabrera Fine Properties</p>
          </div>

          <div className="PropertySample__main__infos__right__card">
            <div className="PropertySample__main__infos__right__card__img">
              <img src={pascalprofil} alt="Luxury villa with sea view in Costa Blanca, Spain" />
            </div>
            <div className="PropertySample__main__infos__right__card__rightcontent">
              <div className="PropertySample__Nameandbadge">
                <div className="PropertySample__Nameandbadge__left">
                  <p>Pascal Bretel</p>
                </div>
                <div className="PropertySample__Nameandbadge__right">
                  <Verified />
                </div>
              </div>
              <div className="PropertySample__Status">
                <p>Real Estate Expert</p>
              </div>

              <p>+1 (346)225-7360</p>
              <div className="PropertySample__email">
                <p>info@luxuryspainproperties.com</p>
              </div>
              <div className="PropertySample__CTA">
                <a href="/contact">
                  <p>Contact us</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PropertySample__description">
        <div className="PropertySample__description__title">
          <p>PROPERTY DESCRIPTION</p>
        </div>
        <div
          className="PropertySample__description__desc"
          dangerouslySetInnerHTML={{ __html: property.description }}
        ></div>
        <div className="PropertySample__description__title">
          <p>PROPERTY DETAILS</p>
        </div>
        <div className="PropertySample__description__blocinfo">
          <div className="PropertySample__description__blocinfo__left">
            <div className="PropertySample__description__blocinfo__title">
              <p>HOUSE</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.housesize}</p>
            </div>
          </div>
          <div className="PropertySample__description__blocinfo__right">
            <div className="PropertySample__description__blocinfo__title">
              <p>PLOT</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.plotsize}</p>
            </div>
          </div>
        </div>

        <div className="PropertySample__description__blocinfo">
          <div className="PropertySample__description__blocinfo__left">
            <div className="PropertySample__description__blocinfo__title">
              <p>BEDROOMS</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.bedrooms}</p>
            </div>
          </div>
          <div className="PropertySample__description__blocinfo__right">
            <div className="PropertySample__description__blocinfo__title">
              <p>BATHROOMS</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.bathrooms}</p>
            </div>
          </div>
        </div>

        <div className="PropertySample__description__blocinfo">
          <div className="PropertySample__description__blocinfo__left">
            <div className="PropertySample__description__blocinfo__title">
              <p>ORIENTATION</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.orientation}</p>
            </div>
          </div>
          <div className="PropertySample__description__blocinfo__right">
            <div className="PropertySample__description__blocinfo__title">
              <p>VIEWS</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.views}</p>
            </div>
          </div>
        </div>

        <div className="PropertySample__description__title">
          <p>LOCATION DETAILS</p>
        </div>
        <div className="PropertySample__description__blocinfo">
          <div className="PropertySample__description__blocinfo__left">
            <div className="PropertySample__description__blocinfo__title">
              <p>AIRPORT</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.airport}</p>
            </div>
          </div>
          <div className="PropertySample__description__blocinfo__right">
            <div className="PropertySample__description__blocinfo__title">
              <p>BEACH</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.beach}</p>
            </div>
          </div>
        </div>

        <div className="PropertySample__description__blocinfo">
          <div className="PropertySample__description__blocinfo__left">
            <div className="PropertySample__description__blocinfo__title">
              <p>CITY</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.city}</p>
            </div>
          </div>
          <div className="PropertySample__description__blocinfo__right">
            <div className="PropertySample__description__blocinfo__title">
              <p>GOLF</p>
            </div>
            <div className="PropertySample__description__blocinfo__data">
              <p>{property.golf}</p>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>

      <div className="PropertySample__main__infos__right__mobile">
        <div className="PropertySample__main__infos__right__card__mobile">
          <div className="PropertySample__main__infos__right__card__img__mobile">
            <img src={pascalphoto} alt="Luxury villa with sea view in Costa Blanca, Spain" />
          </div>
          <div className="PropertySample__main__infos__righ t__card__rightcontent">
            <div className="PropertySample__Nameandbadge">
              <div className="PropertySample__Nameandbadge__left">
                <p>Pascal Bretel</p>
              </div>
              <div className="PropertySample__Nameandbadge__right">
                <Verified />
              </div>
            </div>
            <div className="PropertySample__Status">
              <p>Real Estate Expert</p>
            </div>

            <p>+1 (346)225-7360</p>
            <div className="PropertySample__email">
              <p>info@luxuryspainproperties.com</p>
            </div>
            <div className="PropertySample__CTA">
              <a href="/contact">
                <p>Contact us</p>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="PropertySample__greyline"></div>
      <div className="PropertySample__similarproperties">
        <FeaturedProperties />
      </div>

 
    </div>
  );
}

export default PropertySample;
